
import {
  Component, HostBinding, Input, OnDestroy,
  OnInit, Output, EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-collapse',
    templateUrl: './collapse.component.html',
    styleUrls: ['./collapse.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CollapseComponent implements OnInit, OnDestroy {
  @Output() collapsed = new EventEmitter<boolean>();
  @Input() isCollapsed: boolean = false;
  @Input() title: string;
  @Input() direction: 'topToBottom' | 'rightToLeft' = 'topToBottom';
  @Input() theme: 'default' | 'flat';

  cssClassForCollpase = 'down';
  showTextTitle = true;
  @HostBinding('class') cssClassForHost: string = '';

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.setHostClass();
    this.setShowTextTitle();
  }

  ngOnDestroy() {
  }

  setHostClass() {
    if (this.theme === 'flat') {
      this.cssClassForHost = 'flat';
    }
    this.cssClassForHost += ' ' + this.direction;
  }

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
    this.setShowTextTitle();
    this.collapsed.next(this.isCollapsed);
  }

  setShowTextTitle() {
    if (!this.title) {
      this.showTextTitle = false;
      return;
    }
    if (this.theme === 'flat' && this.isCollapsed) {
      this.showTextTitle = false;
    } else {
      this.showTextTitle = true;
    }
  }
}
